import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './announcementHighlight.module.css';

const AnnouncementHighlight = ({ icon: Icon, label }) => (
    <Box component="li" className={styles.highlight}>
        <Box component="span" className={styles.iconWrap}>
            <Icon className={styles.icon} />
        </Box>
        <Typography component="span" className={styles.label}>
            {label}
        </Typography>
    </Box>
);

AnnouncementHighlight.propTypes = {
    icon: PropTypes.elementType.isRequired,
    label: PropTypes.string.isRequired,
};

export default AnnouncementHighlight;
